
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Http, HttpModule} from '@angular/http';
import {FormsModule} from '@angular/forms';
import {AbsStepTrackerComponent} from './abs-step-tracker.component';

@NgModule({
    imports: [CommonModule, FormsModule, HttpModule],
    declarations: [AbsStepTrackerComponent],
    exports: [AbsStepTrackerComponent]
})
export class AbsStepTrackerModule {}